<template>
  <div class="video-page">
    <van-field 
      v-model="inputUrl" 
      label="直播流地址" 
      type="textarea" 
      placeholder="请输入直播流地址" 
      rows="2" 
    />
    <div class="switch-btn">
      <van-button type="primary" @click="switchToInputUrl">
        切换到输入地址
      </van-button>
      <van-button type="info" @click="switchUrl" style="margin-left: 10px;">
        切换为{{ isHttps ? 'HTTP' : 'HTTPS' }}
      </van-button>
    </div>
    
    <div class="video-container">
      <video
        ref="videoPlayer"
        class="video-js vjs-default-skin"
        controls
        preload="auto"
        width="100%"
        height="100%"
        playsinline
        webkit-playsinline
        x5-playsinline
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        muted
      >
        <source :src="currentUrl" type="application/x-mpegURL">
      </video>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Field, Button } from 'vant'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import Hls from 'hls.js'

Vue.use(Field)
Vue.use(Button)

export default {
  name: 'VideoPlayer',
  data() {
    return {
      httpUrl: 'http://live-hls.snsports.cn/banmalive/game_3131971.m3u8',
      httpsUrl: 'https://live-hls.snsports.cn/banmalive/game_3131971.m3u8',
      inputUrl: 'http://live-hls.snsports.cn/banmalive/game_3131971.m3u8',
      player: null,
      hls: null
    }
  },
  computed: {
    isHttps() {
      // 从 URL 查询参数获取当前模式
      return this.$route.query.mode === 'https'
    },
    currentUrl() {
      // 如果有自定义输入的URL，优先使用输入的URL
      if (this.$route.query.customUrl) {
        return decodeURIComponent(this.$route.query.customUrl)
      }
      return this.isHttps ? this.httpsUrl : this.httpUrl
    }
  },
  watch: {
    // 监听路由变化
    '$route': {
      handler() {
        this.destroyPlayer()
        this.$nextTick(() => {
          this.initPlayer()
        })
      },
      immediate: true
    }
  },
  mounted() {
    // 删除这里的 initPlayer
  },
  beforeDestroy() {
    this.destroyPlayer()
  },
  methods: {
    destroyPlayer() {
      if (this.player) {
        this.player.dispose()
        this.player = null
      }
      if (this.hls) {
        this.hls.destroy()
        this.hls = null
      }
    },
    switchToInputUrl() {
      if (!this.inputUrl) {
        this.$toast('请输入直播流地址')
        return
      }
      
      this.$router.replace({
        path: '/video-test',
        query: { 
          customUrl: encodeURIComponent(this.inputUrl),
          _t: Date.now()
        }
      }).then(() => {
        window.location.reload()
      })
    },
    switchUrl() {
      this.$router.replace({
        path: '/video-test',
        query: { 
          mode: this.isHttps ? 'http' : 'https',
          _t: Date.now()
        }
      }).then(() => {
        window.location.reload()
      })
    },
    initPlayer() {
      const videoElement = this.$refs.videoPlayer

      // 创建新的播放器实例
      this.player = videojs(videoElement, {
        controls: true,
        autoplay: true,
        fluid: true,
        muted: true,
        sources: [{
          src: this.currentUrl,
          type: 'application/x-mpegURL'
        }]
      })

      // 如果浏览器原生支持 HLS
      if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
        this.player.src({
          src: this.currentUrl,
          type: 'application/x-mpegURL'
        })
      } 
      // 使用 hls.js
      else if (Hls.isSupported()) {
        this.hls = new Hls()
        this.hls.loadSource(this.currentUrl)
        this.hls.attachMedia(videoElement)
        
        // 错误处理
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                this.hls.startLoad()
                break
              case Hls.ErrorTypes.MEDIA_ERROR:
                this.hls.recoverMediaError()
                break
              default:
                this.destroyPlayer()
                this.initPlayer()
                break
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-page {
  .video-container {
    margin-top: 16px;
    width: 100%;
    height: 56.25vw;
    position: relative;
    background: #000;
    
    .video-js {
      width: 100%;
      height: 100%;
    }
  }

  .switch-btn {
    margin-top: 16px;
    padding: 0 16px;
    display: flex;
    gap: 10px;
  }
}
</style>
